<span class="comments-icon-wrapper">
  <app-link iconClass="dx-icon-comment" (onClick)="click()" [disabled]="disabled()"></app-link>
  @if (hasUnreadMessages() && !disabled()) { <span class="new-comment-dot"></span> }
</span>